import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { setDoc, doc } from "firebase/firestore";
import { AuthContext } from "../context/AuthContext";

export default function RegisterScreen() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [from, setFrom] = useState("");
  const [tel, setTel] = useState("");

  const handleRegister = async () => {
    if (!firstName || !lastName || !birthDate || !email || !password || !from || !tel) {
      alert("Izpolni vsa polja!");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const firebaseUser = userCredential.user;

      await setDoc(doc(db, "users", firebaseUser.uid), {
        firstName,
        lastName,
        birthDate,
        email,
        from,
        tel,
      });

      if (login) await login(firebaseUser);

      navigate("/izbira");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ textAlign: "center", marginBottom: 20 }}>MeteoPredict</h1>
      <div style={cardStyle}>
        <h2 style={{ textAlign: "center", marginBottom: 20 }}>Registracija</h2>

        <input
          style={inputStyle}
          placeholder="Ime"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <input
          style={inputStyle}
          placeholder="Priimek"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <input
          type="date"
          style={inputStyle}
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
        />
        <input
          style={inputStyle}
          placeholder="E-poštni naslov"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          style={inputStyle}
          placeholder="Geslo"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          style={inputStyle}
          placeholder="Kraj bivanja"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
        />
        <input
          style={inputStyle}
          placeholder="Telefonska številka"
          type="tel"
          value={tel}
          onChange={(e) => setTel(e.target.value)}
        />

        <button style={buttonStyle} onClick={handleRegister}>Registriraj se</button>
      </div>

      <p style={{ textAlign: "center", marginTop: 15 }}>
        Že imaš račun?{" "}
        <span style={{ color: "blue", cursor: "pointer" }} onClick={() => navigate("/prijava")}>
          Prijavi se
        </span>
      </p>
    </div>
  );
}

// --- Styling ---
const containerStyle = {
  maxWidth: "450px",
  margin: "50px auto",
  padding: 20,
  fontFamily: "Arial, sans-serif",
};

const cardStyle = {
  backgroundColor: "#fff",
  padding: 25,
  borderRadius: 12,
  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
};

const inputStyle = {
  padding: "10px",
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14,
};

const buttonStyle = {
  padding: "12px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  backgroundColor: "#3498db",
  color: "#fff",
  fontWeight: "bold",
  fontSize: 14,
};